export default __webpack_public_path__ + "static/media/img-43-bayard.a08ddb99.jpg";